import { render, staticRenderFns } from "./PageListado.vue?vue&type=template&id=0ecf04e5"
import script from "./PageListado.vue?vue&type=script&lang=js"
export * from "./PageListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports